'use client';

import { styled } from '../../styles';
import { ListItem } from '../ListItem';
import { Typography } from '../Typography';

export const StyledFaqItem = styled(ListItem)(({ theme }) => ({
  cursor: 'pointer',
  padding: theme.spacing(3, 4, 3, 0),
  borderBottom: `1px solid ${theme.palette.divider}`,
  color: theme.palette.text2,

  '&:hover': {
    color: theme.palette.stateHover,
  },
}));

export const FaqItemTypography = styled(Typography)(({ theme }) => ({
  marginRight: theme.spacing(8),
}));
